import axios from 'axios'

const saveUserData = formData => axios.post(`${window.APP_CONFIG.VH_API_BASE_URL}/register/addUser`, formData).then(res => res?.data)

const checkUserStatus = keycloakId =>
  axios.get(`${window.APP_CONFIG.VH_API_BASE_URL}/register/status/kc/${keycloakId}`).then(res => res?.data)

const savePaymentDetails = (id, body) =>
  axios.post(`${window.APP_CONFIG.VH_API_BASE_URL}/register/mistake/kc/${id}`, body).then(res => res?.data)

const updateStatus = async data =>
  await axios.post(`${window.APP_CONFIG.VH_API_BASE_URL}/register/choice/kc/${data.keycloakid}`, data).then(res => res?.data)

const getProfile = keycloakId => {
  return axios.get(`${window.APP_CONFIG.VH_API_BASE_URL}/profile/v1/profile/${keycloakId}`).then(res => res?.data)
}
const postUserData = (keycloakId, email) => {
  return axios
    .post(`${window.APP_CONFIG.VH_API_BASE_URL}/register/status/kc/${keycloakId}`, {
      data: { email },
    })
    .then(res => res?.data)
}
export { saveUserData, checkUserStatus, savePaymentDetails, updateStatus, getProfile, postUserData }
